var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdminIcon = function SvgAdminIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40.232 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("path", {
    d: "m27.028 9.514 0.162 0.109c0.524 0.355 1.001 0.74 1.467 1.168q0.184 0.166 0.373 0.324c2.193 1.925 3.405 5.08 3.597 7.928 0.144 3.23 -0.778 6.23 -2.768 8.784l-0.207 0.273 -0.11 0.146 -0.092 0.122 -0.075 0.081h-0.116l-0.042 0.1c-0.28 0.503 -0.847 0.888 -1.293 1.236l-0.161 0.127a18.104 18.104 0 0 1 -0.535 0.395l-0.104 0.073c-2.665 1.873 -6.038 2.538 -9.234 2.014 -2.355 -0.429 -4.57 -1.437 -6.332 -3.078a8.046 8.046 0 0 0 -0.336 -0.291c-0.224 -0.191 -0.408 -0.41 -0.598 -0.635l-0.143 -0.161c-0.853 -0.966 -1.515 -2.088 -2.041 -3.261l-0.06 -0.135c-0.077 -0.178 -0.136 -0.312 -0.136 -0.508l-0.116 -0.058 -0.058 -0.406 -0.116 -0.058c-0.031 -0.111 -0.031 -0.111 -0.056 -0.254a14.081 14.081 0 0 0 -0.131 -0.637 13.277 13.277 0 0 1 -0.162 -5.263l0.036 -0.228c0.192 -1.094 0.569 -2.144 1.066 -3.137l0.066 -0.134a10.661 10.661 0 0 1 1.832 -2.569c0.136 -0.14 0.136 -0.14 0.255 -0.295a2.313 2.313 0 0 1 0.311 -0.319l0.123 -0.105 0.142 -0.121 0.169 -0.148c4.244 -3.683 10.714 -4.252 15.422 -1.079m-7.869 3.782v0.174l-0.058 -0.116c-0.977 0.086 -1.879 0.663 -2.524 1.379 -0.893 1.129 -1.193 2.365 -1.076 3.788 0.043 0.302 0.128 0.584 0.232 0.871l0.051 0.157c0.382 1.086 1.254 1.837 2.195 2.439 0.219 0.145 0.334 0.249 0.407 0.507 0.037 0.267 -0.011 0.441 -0.156 0.671 -0.283 0.225 -0.575 0.315 -0.918 0.417a7.041 7.041 0 0 0 -2.637 1.524 5.029 5.029 0 0 1 -0.273 0.221c-0.274 0.227 -0.483 0.52 -0.7 0.799l-0.13 0.162a10.058 10.058 0 0 0 -0.712 1.057l-0.076 0.129c-0.11 0.19 -0.197 0.352 -0.243 0.568 2.149 2.09 5.004 2.946 7.945 2.915 2.623 -0.041 5.186 -1.113 7.033 -2.973 -0.911 -1.96 -2.496 -3.508 -4.528 -4.296l-0.292 -0.098 -0.159 -0.053 -0.316 -0.101c-0.364 -0.12 -0.364 -0.12 -0.516 -0.293a1.308 1.308 0 0 1 -0.079 -0.472l-0.003 -0.162c0.038 -0.209 0.112 -0.297 0.262 -0.449a7.041 7.041 0 0 1 0.384 -0.246 5.733 5.733 0 0 0 1.009 -0.799l0.114 -0.103c0.279 -0.259 0.461 -0.551 0.641 -0.884l0.078 -0.14c0.605 -1.137 0.637 -2.366 0.271 -3.577a4.546 4.546 0 0 0 -2.264 -2.612c-0.927 -0.417 -1.952 -0.589 -2.961 -0.406",
    fill: "#000000"
  })), _ref3 || (_ref3 = React.createElement("path", {
    d: "m16.9 0.414 0.228 -0.001a41.238 41.238 0 0 1 0.617 0.002q0.323 0.002 0.647 0.001 0.543 0 1.086 0.004 0.628 0.005 1.254 0.003 0.604 0 1.209 0.002l0.513 0.001q0.359 0 0.717 0.004l0.214 -0.001c0.367 0.005 0.603 0.013 0.88 0.266 0.292 0.362 0.24 0.878 0.238 1.321v0.158l-0.002 0.495 -0.001 0.338q0 0.413 -0.002 0.826l0.191 0.042c0.517 0.117 1.017 0.249 1.515 0.433l0.185 0.067a11.366 11.366 0 0 1 1.94 0.908c0.127 0.04 0.127 0.04 0.232 0.058l0.04 -0.098c0.099 -0.175 0.224 -0.299 0.366 -0.44l0.156 -0.157c0.135 -0.12 0.135 -0.12 0.25 -0.12v-0.116h0.116l0.058 -0.174q0.125 -0.11 0.254 -0.213c0.106 -0.084 0.106 -0.084 0.238 -0.221 0.405 -0.405 0.405 -0.405 0.664 -0.494 0.854 0 1.707 1.229 2.259 1.781l0.317 0.316 0.661 0.66 0.763 0.761 0.737 0.736 0.313 0.312 0.436 0.436 0.131 0.13 0.12 0.12 0.104 0.104a0.835 0.835 0 0 1 0.225 0.587l0.005 0.129c-0.071 0.375 -0.4 0.642 -0.665 0.893l-0.236 0.23 -0.372 0.359 -0.36 0.35 -0.114 0.108c-0.203 0.188 -0.203 0.188 -0.254 0.446 0.054 0.124 0.108 0.243 0.173 0.361l0.07 0.129 0.076 0.138c0.442 0.821 0.811 1.668 1.082 2.559q0.05 0.158 0.108 0.315l0.116 0.058v0.116l0.223 -0.003 0.824 -0.007 0.356 -0.004 0.513 -0.004 0.16 -0.003c0.37 0 0.625 0.054 0.899 0.321 0.246 0.395 0.234 0.829 0.231 1.279v0.193l-0.001 0.63v0.44l-0.001 0.919 -0.001 1.06 -0.001 1.024v0.433l-0.001 0.608v0.18c-0.004 0.963 -0.004 0.963 -0.255 1.322 -0.33 0.286 -0.692 0.286 -1.106 0.279l-0.17 -0.001 -0.534 -0.005 -0.364 -0.002 -0.888 -0.008 -0.042 0.179c-0.119 0.493 -0.251 0.974 -0.425 1.45l-0.066 0.184c-0.271 0.728 -0.583 1.47 -1.001 2.128l-0.09 0.181c0.061 0.17 0.153 0.283 0.281 0.406l0.101 0.099 0.108 0.104 0.226 0.222 0.357 0.347 0.345 0.337 0.108 0.103c0.222 0.219 0.35 0.405 0.448 0.703 -0.012 0.236 -0.038 0.443 -0.174 0.639l-0.291 0.232 -0.113 0.142c-0.113 0.141 -0.232 0.242 -0.373 0.355 -0.15 0.133 -0.275 0.288 -0.404 0.441 -0.118 0.131 -0.248 0.234 -0.387 0.34l-0.058 0.116h-0.116l-0.058 0.174h-0.116l-0.036 0.095a1.71 1.71 0 0 1 -0.428 0.486h-0.116l-0.043 0.102a1.308 1.308 0 0 1 -0.305 0.363h-0.116l-0.044 0.104c-0.08 0.145 -0.166 0.223 -0.293 0.328a5.029 5.029 0 0 0 -0.668 0.664 3.52 3.52 0 0 1 -0.486 0.468c-0.218 0.195 -0.419 0.409 -0.622 0.622a0.986 0.986 0 0 1 -0.703 0.279l-0.129 0.007c-0.198 -0.048 -0.283 -0.176 -0.422 -0.323l-0.173 -0.178 -0.093 -0.096 -0.413 -0.421 -0.217 -0.223 -0.316 -0.323 -0.098 -0.102c-0.101 -0.104 -0.101 -0.104 -0.257 -0.225 -0.181 0.026 -0.322 0.099 -0.481 0.187l-0.146 0.079 -0.157 0.085c-1.002 0.534 -2.101 1.002 -3.222 1.215l-0.003 0.221 -0.013 0.82 -0.005 0.354 -0.008 0.51 -0.001 0.158c-0.009 0.391 -0.051 0.75 -0.344 1.036 -0.243 0.154 -0.398 0.225 -0.69 0.225l-0.19 0.001h-0.208l-0.219 0.001 -0.595 0.001H20.609q-0.605 0 -1.21 0.002 -0.52 0.002 -1.04 0.001l-0.621 0.001h-0.693l-0.206 0.001c-0.354 -0.002 -0.62 -0.02 -0.929 -0.197 -0.543 -0.585 -0.353 -1.669 -0.346 -2.415l0.002 -0.206 0.002 -0.186c0.001 -0.16 0.001 -0.16 -0.063 -0.329a4.023 4.023 0 0 0 -0.41 -0.127l-0.117 -0.031 -0.286 -0.074 -0.058 0.116v-0.174l-0.14 -0.016a4.023 4.023 0 0 1 -0.752 -0.248l-0.155 -0.062c-0.399 -0.164 -0.785 -0.347 -1.167 -0.546 -0.283 -0.146 -0.573 -0.274 -0.863 -0.404l-0.149 0.152 -0.551 0.558 -0.237 0.241 -0.343 0.347 -0.107 0.109c-0.237 0.237 -0.462 0.439 -0.812 0.462l-0.128 -0.006 -0.058 0.116 -0.073 -0.077a2.514 2.514 0 0 0 -0.313 -0.251 7.041 7.041 0 0 1 -0.75 -0.676l-0.144 -0.143 -0.465 -0.465 -0.325 -0.325 -0.678 -0.679 -0.784 -0.784 -0.756 -0.755 -0.321 -0.321 -0.448 -0.449 -0.134 -0.134c-0.521 -0.525 -0.521 -0.525 -0.544 -0.9 0.034 -0.673 0.896 -1.287 1.364 -1.729q0.136 -0.129 0.27 -0.259l0.16 -0.153c0.124 -0.136 0.124 -0.136 0.103 -0.296a2.514 2.514 0 0 0 -0.165 -0.359l-0.069 -0.126 -0.075 -0.135c-0.527 -0.974 -1.25 -2.33 -1.25 -3.466l-0.097 0.002q-0.499 0.008 -0.998 0.011l-0.372 0.005q-0.268 0.004 -0.536 0.005l-0.167 0.004c-0.355 0 -0.561 -0.05 -0.851 -0.258 -0.314 -0.37 -0.272 -0.805 -0.276 -1.27l-0.005 -0.271q-0.006 -0.478 -0.008 -0.957l-0.001 -0.19a230.328 230.328 0 0 1 0.001 -3.119l0.001 -0.175q0.003 -0.449 0.011 -0.896l0.004 -0.254c0.008 -0.785 0.008 -0.785 0.275 -1.054 0.313 -0.266 0.574 -0.268 0.967 -0.268l0.178 -0.003q0.282 -0.004 0.56 -0.005l0.381 -0.005 0.932 -0.01 0.038 -0.121c0.358 -1.123 0.772 -2.218 1.341 -3.254 0.105 -0.189 0.105 -0.189 0.117 -0.399a0.704 0.704 0 0 0 -0.208 -0.294l-0.104 -0.101 -0.113 -0.107 -0.235 -0.228q-0.185 -0.179 -0.372 -0.357l-0.358 -0.347 -0.113 -0.105c-0.251 -0.248 -0.396 -0.491 -0.458 -0.843 0.044 -0.294 0.142 -0.484 0.348 -0.697h0.116l0.039 -0.097c0.101 -0.178 0.236 -0.311 0.381 -0.454l0.091 -0.091 0.19 -0.189 0.289 -0.287 0.185 -0.184 0.085 -0.085c0.191 -0.188 0.39 -0.359 0.597 -0.53a4.023 4.023 0 0 0 0.178 -0.203c0.392 -0.471 0.392 -0.471 0.635 -0.551v-0.116h0.116l0.036 -0.094c0.114 -0.197 0.267 -0.343 0.428 -0.502l0.097 -0.098c0.238 -0.235 0.238 -0.235 0.369 -0.235l0.044 -0.102c0.079 -0.146 0.169 -0.243 0.287 -0.361l0.129 -0.13 0.135 -0.134 0.132 -0.134c0.628 -0.626 0.628 -0.626 1.011 -0.625 0.314 0.012 0.473 0.115 0.701 0.323v0.116h0.116c0.079 0.081 0.079 0.081 0.174 0.196 0.254 0.299 0.53 0.573 0.809 0.849l0.154 0.153 0.373 0.37 0.202 -0.098c1.17 -0.562 2.353 -1.092 3.624 -1.38 0.12 -0.02 0.12 -0.02 0.179 -0.09q0.005 -0.253 0.002 -0.508l-0.002 -0.318 -0.005 -0.501 -0.004 -0.484 -0.002 -0.149c-0.003 -0.767 -0.003 -0.767 0.211 -1.055 0.353 -0.345 0.664 -0.352 1.143 -0.345m0.284 1.676 -0.058 2.555 -0.174 0.291v0.116c-0.201 0.084 -0.4 0.15 -0.613 0.204l-0.187 0.049 -0.198 0.051c-1.13 0.301 -2.205 0.654 -3.234 1.215l-0.178 0.097a19.11 19.11 0 0 0 -0.342 0.191c-0.354 0.194 -0.648 0.3 -1.053 0.224 -0.165 -0.083 -0.165 -0.083 -0.294 -0.199l-0.144 -0.128a24.139 24.139 0 0 1 -0.665 -0.66l-0.149 -0.145c-0.21 -0.215 -0.407 -0.442 -0.605 -0.668 -0.338 0.281 -0.648 0.581 -0.957 0.893l-0.156 0.157 -0.408 0.409 -0.414 0.415 -0.606 0.609 -0.535 0.536 -0.158 0.158 -0.772 0.769c0.209 0.256 0.432 0.494 0.668 0.726l0.088 0.086 0.363 0.355 0.268 0.263 0.16 0.156c0.189 0.214 0.299 0.395 0.331 0.682a1.056 1.056 0 0 1 -0.165 0.465l-0.095 0.167 -0.103 0.178c-0.752 1.354 -1.285 2.746 -1.709 4.233 -0.109 0.325 -0.109 0.325 -0.278 0.423a3.017 3.017 0 0 1 -0.659 0.082L4.023 17.054q-0.357 0.018 -0.715 0.015H2.09v5.399l2.322 0.058c0.482 0.206 0.482 0.206 0.58 0.348 0.061 0.168 0.061 0.168 0.117 0.372l0.031 0.112 0.065 0.236 0.174 0.617 0.035 0.123q0.214 0.736 0.507 1.444l0.052 0.128c0.281 0.68 0.623 1.322 0.987 1.961l0.063 0.115 0.065 0.117c0.082 0.187 0.093 0.382 0.051 0.579a3.42 3.42 0 0 1 -0.585 0.708l-0.101 0.1 -0.316 0.31 -0.418 0.411 -0.098 0.095q-0.116 0.115 -0.224 0.234v0.116c0.077 0.079 0.077 0.079 0.184 0.163 0.369 0.314 0.705 0.661 1.047 1.003l0.22 0.22 0.459 0.459 0.588 0.588 0.454 0.454 0.217 0.217 0.302 0.302 0.091 0.091c0.205 0.206 0.205 0.206 0.271 0.336 0.229 -0.098 0.397 -0.239 0.58 -0.406v-0.116l0.104 -0.046c0.137 -0.074 0.222 -0.153 0.33 -0.266l0.112 -0.116 0.229 -0.24c0.262 -0.269 0.475 -0.475 0.864 -0.51 0.254 0.019 0.432 0.103 0.651 0.225l0.25 0.134 0.131 0.071c1.167 0.632 2.339 1.146 3.635 1.451 0.67 0.158 0.67 0.158 0.9 0.428 0.142 0.266 0.144 0.475 0.144 0.77l0.003 0.163q0.004 0.255 0.005 0.511l0.005 0.348q0.006 0.424 0.009 0.85h0.116l-0.116 0.116h5.69l0.058 -2.555c0.328 -0.492 0.64 -0.546 1.183 -0.675 1.41 -0.355 2.803 -0.921 4.038 -1.694a1.066 1.066 0 0 1 0.759 -0.128c0.262 0.157 0.469 0.341 0.677 0.561l0.183 0.189 0.284 0.297 0.278 0.287 0.084 0.092c0.089 0.094 0.089 0.094 0.236 0.2 0.255 0 0.386 -0.127 0.562 -0.301l0.103 -0.105 0.11 -0.11 0.357 -0.361 0.248 -0.249 0.653 -0.658q0.332 -0.336 0.667 -0.671l1.306 -1.32c-0.107 -0.231 -0.257 -0.387 -0.439 -0.562l-0.096 -0.095 -0.406 -0.397 -0.297 -0.292 -0.093 -0.09c-0.24 -0.237 -0.454 -0.48 -0.471 -0.829 0.112 -0.34 0.263 -0.635 0.443 -0.943 0.319 -0.559 0.585 -1.135 0.835 -1.727l0.049 -0.114c0.27 -0.633 0.435 -1.294 0.601 -1.959l0.056 -0.221 0.049 -0.198c0.092 -0.286 0.207 -0.483 0.464 -0.643 0.827 -0.276 1.741 -0.096 2.612 -0.116v-5.341a1.106 1.106 0 0 0 -0.407 -0.067l-0.142 -0.002 -0.152 -0.001 -0.32 -0.005q-0.251 -0.004 -0.504 -0.006l-0.487 -0.007 -0.152 -0.001c-0.273 -0.006 -0.465 -0.019 -0.682 -0.201 -0.226 -0.338 -0.309 -0.773 -0.413 -1.161a15.489 15.489 0 0 0 -1.386 -3.309c-0.417 -0.759 -0.417 -0.759 -0.348 -1.103 0.154 -0.308 0.401 -0.523 0.649 -0.757 0.12 -0.102 0.12 -0.102 0.107 -0.229l0.103 -0.045c0.14 -0.076 0.231 -0.159 0.343 -0.273l0.117 -0.118 0.12 -0.123 0.123 -0.125 0.298 -0.305 -0.163 -0.192 -0.092 -0.109c-0.129 -0.145 -0.129 -0.145 -0.268 -0.28h-0.116l-0.04 -0.098c-0.132 -0.232 -0.287 -0.398 -0.541 -0.483v-0.116h-0.116v-0.116c-0.08 -0.079 -0.08 -0.079 -0.185 -0.16a2.514 2.514 0 0 1 -0.363 -0.359 2.615 2.615 0 0 0 -0.343 -0.345c-0.36 -0.311 -0.69 -0.653 -1.025 -0.99l-0.203 -0.204 -0.494 -0.498c-0.234 0.093 -0.385 0.258 -0.556 0.437l-0.19 0.194 -0.296 0.306 -0.288 0.295 -0.086 0.092c-0.238 0.241 -0.524 0.467 -0.874 0.484a3.52 3.52 0 0 1 -0.877 -0.395 11.064 11.064 0 0 0 -1.478 -0.714l-0.13 -0.052a14.685 14.685 0 0 0 -2.29 -0.691c-0.456 -0.101 -0.628 -0.201 -0.889 -0.592l-0.058 -2.612z",
    fill: "#000000"
  })), _ref4 || (_ref4 = React.createElement("path", {
    d: "M19.992 9.042h0.141c0.733 0.001 1.44 0.038 2.16 0.189l0.151 0.03c0.736 0.15 1.424 0.368 2.113 0.667l0.125 0.053c2.59 1.112 4.609 3.281 5.681 5.868 0.507 1.307 0.722 2.634 0.711 4.031l-0.001 0.135c-0.015 2.581 -0.855 4.855 -2.394 6.922a4.023 4.023 0 0 1 -0.37 -0.591 8.569 8.569 0 0 0 -4.39 -3.821v-0.116c0.085 -0.081 0.085 -0.081 0.203 -0.178 1.012 -0.868 1.764 -2.209 1.944 -3.537 0.136 -1.86 -0.281 -3.475 -1.467 -4.921a5.985 5.985 0 0 0 -3.699 -1.987c-0.289 -0.02 -0.577 -0.025 -0.867 -0.025h-0.121c-1.383 0.005 -2.654 0.458 -3.714 1.361l-0.151 0.125a6.005 6.005 0 0 0 -2.067 4.08c-0.086 1.728 0.441 3.332 1.601 4.617q0.244 0.27 0.5 0.526l-0.173 0.081c-1.873 0.897 -3.569 2.433 -4.471 4.33h-0.116c-1.82 -2.171 -2.568 -5.21 -2.34 -7.99 0.159 -1.724 0.704 -3.385 1.643 -4.84l0.125 -0.196c0.279 -0.419 0.589 -0.784 0.936 -1.147 0.121 -0.128 0.235 -0.255 0.347 -0.392 0.188 -0.221 0.401 -0.403 0.624 -0.587l0.086 -0.073c2.066 -1.76 4.556 -2.609 7.251 -2.611",
    fill: "#EDEBEB"
  })), _ref5 || (_ref5 = React.createElement("path", {
    d: "M3.541 30.827c0.088 0.079 0.088 0.079 0.174 0.174v0.116l0.232 0.116v0.116l0.095 0.037c0.19 0.11 0.331 0.261 0.483 0.416l0.091 0.092 0.177 0.181 0.234 0.234c0.146 0.147 0.283 0.3 0.42 0.455 0.208 0.231 0.422 0.442 0.66 0.643 0.162 0.138 0.31 0.284 0.455 0.439v0.116l0.103 0.045c0.143 0.078 0.237 0.165 0.352 0.281l0.129 0.13 0.138 0.14 0.143 0.144 0.451 0.455 0.452 0.456 0.281 0.284 0.128 0.129 0.113 0.115c0.188 0.176 0.355 0.158 0.601 0.155a0.845 0.845 0 0 0 0.421 -0.125c0.061 -0.108 0.061 -0.108 0.116 -0.232 0.145 -0.16 0.145 -0.16 0.291 -0.291h0.116l0.043 -0.102c0.083 -0.15 0.176 -0.25 0.305 -0.363h0.116c-0.125 0.278 -0.324 0.46 -0.537 0.671l-0.116 0.119c-0.249 0.25 -0.48 0.475 -0.85 0.499l-0.125 -0.009 -0.058 0.116 -0.073 -0.077a2.615 2.615 0 0 0 -0.312 -0.251 6.638 6.638 0 0 1 -0.751 -0.678l-0.144 -0.144 -0.466 -0.467 -0.325 -0.325 -0.679 -0.68 -0.785 -0.786 -0.757 -0.757 -0.322 -0.322 -0.448 -0.449 -0.135 -0.135 -0.123 -0.124 -0.107 -0.107c-0.14 -0.153 -0.205 -0.235 -0.205 -0.447",
    fill: "#98999A"
  })), _ref6 || (_ref6 = React.createElement("path", {
    d: "M9.521 3.367c0.167 0.08 0.268 0.163 0.406 0.291v0.116h0.116c0.08 0.081 0.08 0.081 0.175 0.196 0.251 0.296 0.518 0.575 0.79 0.853l0.147 0.155 0.143 0.145 0.128 0.132c0.125 0.105 0.125 0.105 0.289 0.072l0.13 -0.043v0.116l-0.291 0.116 -0.069 -0.072a129.748 129.748 0 0 0 -0.723 -0.74L10.49 4.426l-0.389 -0.395 -0.12 -0.125c-0.258 -0.258 -0.442 -0.382 -0.81 -0.421 -0.626 0.187 -1.122 0.882 -1.575 1.338l-0.196 0.197 -0.511 0.513 -0.524 0.525q-0.513 0.512 -1.025 1.026l-0.058 -0.174 0.153 -0.12c0.174 -0.145 0.316 -0.305 0.461 -0.478 0.312 -0.369 0.312 -0.369 0.548 -0.448v-0.116h0.116l0.036 -0.094c0.114 -0.197 0.267 -0.343 0.428 -0.502l0.097 -0.098c0.237 -0.236 0.237 -0.236 0.368 -0.236l0.044 -0.102c0.079 -0.146 0.169 -0.243 0.287 -0.361l0.129 -0.13 0.135 -0.134 0.132 -0.134c0.708 -0.704 0.708 -0.704 1.306 -0.591",
    fill: "#959697"
  })), _ref7 || (_ref7 = React.createElement("path", {
    d: "M31.233 3.425c0.14 0.112 0.14 0.112 0.297 0.258l0.09 0.083c0.478 0.45 0.94 0.914 1.405 1.377l0.155 0.154 0.726 0.724q0.416 0.416 0.835 0.831 0.364 0.361 0.727 0.724l0.309 0.307q0.215 0.213 0.428 0.427l0.13 0.127 0.117 0.119 0.103 0.102c0.096 0.131 0.116 0.239 0.137 0.397 -0.088 -0.079 -0.088 -0.079 -0.174 -0.174v-0.116h-0.116V8.65h-0.116v-0.116l-0.174 -0.058c-0.088 -0.091 -0.088 -0.091 -0.181 -0.207a5.532 5.532 0 0 0 -0.631 -0.62c-0.205 -0.179 -0.205 -0.179 -0.291 -0.277v-0.116l-0.098 -0.04c-0.299 -0.169 -0.498 -0.455 -0.715 -0.715a4.023 4.023 0 0 0 -0.431 -0.399 3.017 3.017 0 0 1 -0.419 -0.444c-0.074 -0.094 -0.074 -0.094 -0.193 -0.145v-0.116l-0.174 -0.058v-0.116l-0.105 -0.047a1.207 1.207 0 0 1 -0.318 -0.248l-0.105 -0.106 -0.108 -0.111 -0.107 -0.109 -0.207 -0.211 -0.253 -0.255q-0.121 -0.121 -0.239 -0.245c-0.258 -0.272 -0.424 -0.404 -0.811 -0.416l-0.189 0.008v-0.116a0.885 0.885 0 0 1 0.697 0.058",
    fill: "#949597"
  })), _ref8 || (_ref8 = React.createElement("path", {
    d: "M35.53 13.469c0.172 0.145 0.228 0.29 0.302 0.501l0.068 0.193 0.069 0.202 0.138 0.395 0.061 0.177a3.017 3.017 0 0 0 0.174 0.389l0.058 0.116 0.223 -0.003 0.824 -0.007 0.356 -0.004 0.513 -0.004 0.16 -0.003c0.373 0 0.627 0.055 0.902 0.325 0.117 0.19 0.139 0.345 0.156 0.566h-0.116l-0.056 -0.34c-0.09 -0.187 -0.222 -0.277 -0.407 -0.356 -0.209 -0.033 -0.415 -0.031 -0.627 -0.029l-0.181 -0.002q-0.285 -0.003 -0.571 -0.002l-0.573 -0.002q-0.178 -0.002 -0.356 0l-0.162 -0.001h-0.143l-0.117 -0.021a1.106 1.106 0 0 1 -0.185 -0.468 7.041 7.041 0 0 0 -0.376 -1.096l-0.053 -0.131 -0.048 -0.117c-0.033 -0.105 -0.033 -0.105 -0.033 -0.279",
    fill: "#939595"
  })), _ref9 || (_ref9 = React.createElement("path", {
    d: "M30.769 5.167c0.195 0.083 0.325 0.188 0.465 0.348v0.116h0.116c0.146 0.135 0.276 0.271 0.395 0.428 0.108 0.13 0.21 0.227 0.337 0.336 0.254 0.22 0.493 0.456 0.729 0.695l0.121 0.122 0.23 0.232 0.392 0.393 0.58 0.58 -0.058 0.116c-0.351 -0.276 -0.351 -0.276 -0.465 -0.406v-0.116h-0.116V7.896l-0.102 -0.043a1.308 1.308 0 0 1 -0.363 -0.305v-0.116l-0.232 -0.116v-0.116l-0.105 -0.047a1.207 1.207 0 0 1 -0.309 -0.236l-0.103 -0.102 -0.108 -0.11 -0.113 -0.113 -0.353 -0.357 -0.24 -0.241 -0.584 -0.595c-0.232 0.107 -0.39 0.261 -0.566 0.443l-0.09 0.091 -0.215 0.221 -0.116 -0.058 0.073 -0.072 0.329 -0.327 0.116 -0.115 0.111 -0.11 0.103 -0.102c0.088 -0.085 0.088 -0.085 0.14 -0.203",
    fill: "#98989A"
  })), _ref10 || (_ref10 = React.createElement("path", {
    d: "M34.542 28.33c0.163 0.074 0.283 0.152 0.41 0.278l0.101 0.099 0.107 0.106 0.111 0.11 0.231 0.23 0.354 0.349 0.225 0.224 0.107 0.105c0.218 0.221 0.347 0.409 0.445 0.706 -0.012 0.236 -0.038 0.443 -0.174 0.639l-0.291 0.232 -0.113 0.142a2.213 2.213 0 0 1 -0.372 0.354c-0.154 0.137 -0.283 0.295 -0.414 0.453 -0.088 0.098 -0.088 0.098 -0.203 0.155a0.654 0.654 0 0 1 0.212 -0.407l0.094 -0.093 0.098 -0.095 0.097 -0.098c0.239 -0.236 0.239 -0.236 0.371 -0.236l0.045 -0.103c0.077 -0.142 0.168 -0.236 0.282 -0.351 0.148 -0.167 0.193 -0.228 0.236 -0.454 -0.088 -0.43 -0.416 -0.7 -0.722 -0.994l-0.238 -0.231 -0.106 -0.102c-0.077 -0.089 -0.077 -0.089 -0.077 -0.205l-0.098 -0.04c-0.175 -0.099 -0.299 -0.224 -0.44 -0.366l-0.157 -0.156c-0.12 -0.134 -0.12 -0.134 -0.12 -0.25",
    fill: "#959697"
  })), _ref11 || (_ref11 = React.createElement("path", {
    d: "M29.318 11.495c0.302 0.243 0.541 0.495 0.772 0.806l0.099 0.131c0.706 0.949 1.235 1.974 1.683 3.069l0.06 0.144c0.084 0.21 0.136 0.384 0.114 0.612a2.213 2.213 0 0 1 -0.236 -0.474c-0.498 -1.291 -1.078 -2.465 -1.969 -3.532l-0.257 -0.316 -0.116 -0.141c-0.092 -0.124 -0.092 -0.124 -0.149 -0.298",
    fill: "#929495"
  })), _ref12 || (_ref12 = React.createElement("path", {
    d: "m34.368 30.885 0.174 0.058 -2.844 2.844 -0.058 -0.174z",
    fill: "#9A9C9C"
  })), _ref13 || (_ref13 = React.createElement("path", {
    d: "M5.573 30.188h0.116a2.313 2.313 0 0 1 -0.291 0.465l0.103 0.045c0.144 0.078 0.238 0.166 0.354 0.282l0.131 0.131 0.139 0.141 0.144 0.144 0.453 0.456 0.308 0.309 0.75 0.757 -0.116 0.116 -0.494 -0.486 -0.143 -0.14 -0.135 -0.134 -0.126 -0.124c-0.09 -0.104 -0.09 -0.104 -0.09 -0.219l-0.099 -0.042a1.81 1.81 0 0 1 -0.409 -0.336l-0.141 -0.14c-0.107 -0.121 -0.107 -0.121 -0.107 -0.236l-0.103 -0.047a2.012 2.012 0 0 1 -0.347 -0.235l-0.108 -0.086c-0.08 -0.096 -0.08 -0.096 -0.08 -0.328h0.116l0.058 -0.174h0.116z",
    fill: "#989A9B"
  })), _ref14 || (_ref14 = React.createElement("path", {
    d: "M36.335 23.969h0.306l0.176 0.001h0.179l0.569 0.002 0.385 0.001 0.946 0.003 -0.058 0.116h-2.555l-0.232 0.929 -0.174 0.406c-0.074 -0.222 -0.026 -0.313 0.047 -0.533 0.072 -0.223 0.142 -0.444 0.196 -0.671 0.061 -0.243 0.061 -0.243 0.213 -0.253",
    fill: "#959798"
  })), _ref15 || (_ref15 = React.createElement("path", {
    d: "M33.149 27.692c0.04 0.102 0.04 0.102 0.058 0.232l-0.083 0.107c-0.134 0.186 -0.126 0.336 -0.119 0.559 0.048 0.254 0.197 0.386 0.383 0.555l0.11 0.106a25.145 25.145 0 0 0 0.348 0.328l0.348 0.333 0.217 0.205q0.127 0.121 0.247 0.246v0.116c-0.228 -0.093 -0.383 -0.25 -0.553 -0.422l-0.092 -0.092 -0.19 -0.191 -0.291 -0.29 -0.186 -0.186 -0.088 -0.086c-0.233 -0.236 -0.443 -0.48 -0.459 -0.823 0.068 -0.263 0.169 -0.491 0.348 -0.697",
    fill: "#98999A"
  })), _ref16 || (_ref16 = React.createElement("path", {
    d: "M22.7 2.032h0.291l0.001 0.1q0.003 0.513 0.011 1.026l0.004 0.382q0.002 0.276 0.007 0.55v0.172c0.005 0.253 0.01 0.4 0.147 0.62a0.905 0.905 0 0 0 0.339 0.216l0.187 0.069v0.058c-0.213 0.02 -0.321 0.017 -0.504 -0.098 -0.221 -0.221 -0.318 -0.383 -0.328 -0.697q0 -0.164 0.003 -0.327l0.001 -0.174 0.005 -0.55 0.002 -0.373q0.003 -0.458 0.008 -0.914z",
    fill: "#929496"
  })), _ref17 || (_ref17 = React.createElement("path", {
    d: "M24.789 24.615c0.264 0.083 0.421 0.221 0.621 0.41 0.196 0.195 0.196 0.195 0.424 0.345v0.116l0.101 0.04c0.626 0.36 1.086 1.299 1.441 1.915l0.061 0.106c0.139 0.246 0.139 0.246 0.139 0.377h-0.116l-0.109 -0.204a9.555 9.555 0 0 0 -2.424 -2.931l-0.139 -0.116z",
    fill: "#969799"
  })), _ref18 || (_ref18 = React.createElement("path", {
    d: "M28.569 34.434a0.905 0.905 0 0 1 0.314 0.249l0.115 0.125 0.121 0.134 0.249 0.271 0.124 0.134c0.244 0.262 0.5 0.512 0.755 0.763l0.232 0.232c-0.298 -0.085 -0.46 -0.268 -0.666 -0.485l-0.216 -0.222 -0.338 -0.351 -0.328 -0.338 -0.102 -0.108c-0.104 -0.11 -0.104 -0.11 -0.267 -0.238 -0.176 0.024 -0.311 0.094 -0.465 0.18l-0.131 0.071 -0.27 0.151 -0.13 0.071 -0.118 0.066c-0.107 0.041 -0.107 0.041 -0.281 -0.016q0.312 -0.177 0.624 -0.352l0.179 -0.103 0.172 -0.096 0.159 -0.09c0.144 -0.057 0.144 -0.057 0.266 -0.05",
    fill: "#929495"
  })), _ref19 || (_ref19 = React.createElement("path", {
    d: "m12.714 27.402 0.058 0.174 -0.091 0.171c-0.102 0.164 -0.102 0.164 -0.047 0.291 0.499 0.746 1.642 1.291 2.401 1.744 -0.174 0.058 -0.174 0.058 -0.378 -0.041q-0.126 -0.072 -0.249 -0.148l-0.133 -0.079c-0.432 -0.265 -0.824 -0.57 -1.213 -0.893l-0.192 -0.157q-0.224 -0.182 -0.447 -0.366a1.81 1.81 0 0 1 0.178 -0.479l0.063 -0.125z",
    fill: "#969899"
  })), _ref20 || (_ref20 = React.createElement("path", {
    d: "M3.425 8.882c0.067 0.202 0.058 0.368 0.058 0.58 0.007 0.132 0.007 0.132 0.058 0.232 0.11 0.064 0.11 0.064 0.232 0.116 0.102 0.088 0.102 0.088 0.174 0.174v0.116l0.095 0.036c0.191 0.111 0.347 0.256 0.486 0.428v0.116l0.103 0.045c0.14 0.076 0.235 0.161 0.347 0.274l0.108 0.107c0.081 0.099 0.081 0.099 0.081 0.214l0.174 0.058v0.116c-0.247 -0.097 -0.418 -0.282 -0.604 -0.465l-0.107 -0.105 -0.223 -0.221 -0.341 -0.333 -0.217 -0.215 -0.103 -0.099a1.458 1.458 0 0 1 -0.437 -0.827c0.047 -0.207 0.047 -0.207 0.116 -0.348",
    fill: "#969798"
  })), _ref21 || (_ref21 = React.createElement("path", {
    d: "M28.447 32.743c0.37 -0.025 0.504 0.009 0.813 0.232q0.171 0.156 0.333 0.319l0.091 0.092 0.188 0.19 0.288 0.289 0.184 0.185 0.086 0.086c0.145 0.147 0.279 0.296 0.397 0.465 -0.236 -0.029 -0.323 -0.141 -0.472 -0.319a7.041 7.041 0 0 0 -0.722 -0.715 10.058 10.058 0 0 1 -0.513 -0.502c-0.152 -0.146 -0.274 -0.159 -0.477 -0.18l-0.144 -0.015 -0.111 -0.01z",
    fill: "#97999A"
  })), _ref22 || (_ref22 = React.createElement("path", {
    d: "m33.614 10.45 0.116 0.058 -0.111 0.107 -0.144 0.141 -0.143 0.139c-0.147 0.16 -0.235 0.279 -0.251 0.498 0.034 0.405 0.171 0.691 0.379 1.036 0.213 0.359 0.386 0.697 0.501 1.099 -0.215 -0.144 -0.285 -0.311 -0.392 -0.537l-0.123 -0.252 -0.062 -0.129a12.07 12.07 0 0 0 -0.183 -0.354l-0.057 -0.108 -0.156 -0.292a1.167 1.167 0 0 1 -0.072 -0.591c0.166 -0.324 0.437 -0.563 0.697 -0.813",
    fill: "#979899"
  })), _ref23 || (_ref23 = React.createElement("path", {
    d: "M17.068 35.298h0.116l0.058 2.381 0.116 0.058 -0.174 0.058v0.116h-0.116z",
    fill: "#949697"
  })), _ref24 || (_ref24 = React.createElement("path", {
    d: "M28.33 32.975c-2.322 1.277 -2.322 1.277 -2.844 1.277v-0.116l0.109 -0.043c0.728 -0.292 1.436 -0.597 2.12 -0.984l0.143 -0.078 0.125 -0.07c0.14 -0.051 0.21 -0.034 0.348 0.015",
    fill: "#969899"
  })), _ref25 || (_ref25 = React.createElement("path", {
    d: "M5.167 9.23c0.262 0.14 0.453 0.318 0.66 0.526l0.319 0.319 0.331 0.328 0.21 0.209 0.101 0.099c0.159 0.161 0.254 0.272 0.296 0.493l-0.203 -0.167 -0.115 -0.094 -0.089 -0.086v-0.116l-0.105 -0.044a1.006 1.006 0 0 1 -0.317 -0.286 4.325 4.325 0 0 0 -0.594 -0.573l-0.088 -0.084v-0.116l-0.106 -0.047a0.905 0.905 0 0 1 -0.301 -0.243z",
    fill: "#9A9C9C"
  })), _ref26 || (_ref26 = React.createElement("path", {
    d: "M15.559 18.983c0.187 0.094 0.205 0.294 0.269 0.483 0.287 0.801 0.798 1.563 1.531 2.014v0.116c-0.265 -0.082 -0.437 -0.23 -0.628 -0.424l-0.093 -0.094c-0.542 -0.566 -0.971 -1.313 -1.08 -2.095",
    fill: "#939596"
  })), _ref27 || (_ref27 = React.createElement("path", {
    d: "M23.802 0.522c0.191 0.016 0.29 0.057 0.447 0.171 0.287 0.38 0.267 0.877 0.249 1.336l-0.004 0.158 -0.016 0.492 -0.01 0.336q-0.012 0.409 -0.026 0.818h-0.058l-0.003 -0.228q-0.007 -0.42 -0.015 -0.841l-0.006 -0.363 -0.009 -0.523 -0.002 -0.163c-0.007 -0.301 -0.031 -0.559 -0.138 -0.842 -0.139 -0.136 -0.139 -0.136 -0.291 -0.232z",
    fill: "#959798"
  })), _ref28 || (_ref28 = React.createElement("path", {
    d: "M17.416 21.655c0.211 0.037 0.352 0.128 0.526 0.25l0.151 0.105c0.201 0.162 0.295 0.284 0.361 0.534 0.009 0.258 -0.04 0.396 -0.167 0.621 -0.218 0.231 -0.503 0.347 -0.813 0.406 -0.132 -0.025 -0.132 -0.025 -0.232 -0.058l0.172 -0.055 0.224 -0.075 0.113 -0.036c0.226 -0.077 0.366 -0.14 0.479 -0.356 0.037 -0.128 0.037 -0.128 0.047 -0.262l0.016 -0.133a0.553 0.553 0 0 0 -0.121 -0.361c-0.163 -0.125 -0.163 -0.125 -0.352 -0.239 -0.339 -0.213 -0.339 -0.213 -0.402 -0.341",
    fill: "#969798"
  })), _ref29 || (_ref29 = React.createElement("path", {
    d: "M11.263 32.743c0.357 -0.029 0.576 0.057 0.888 0.224l0.135 0.069 0.279 0.146 0.428 0.223 0.272 0.142 0.13 0.067c0.299 0.159 0.299 0.159 0.364 0.289a1.911 1.911 0 0 1 -0.579 -0.193l-0.165 -0.082 -0.17 -0.086 -0.167 -0.084q-0.455 -0.227 -0.894 -0.484c-0.173 -0.085 -0.329 -0.103 -0.521 -0.115z",
    fill: "#969899"
  })), _ref30 || (_ref30 = React.createElement("path", {
    d: "m10.914 11.205 0.174 0.058 -0.145 0.151a12.774 12.774 0 0 0 -1.539 1.939l-0.058 -0.174a4.023 4.023 0 0 1 0.254 -0.377l0.08 -0.11c0.338 -0.457 0.686 -0.902 1.099 -1.293 0.083 -0.077 0.083 -0.077 0.135 -0.194",
    fill: "#949597"
  })), _ref31 || (_ref31 = React.createElement("path", {
    d: "m32.684 34.717 0.058 0.174 -0.127 0.098c-0.242 0.199 -0.456 0.426 -0.675 0.652l-0.243 0.247 -0.123 0.128 -0.12 0.122 -0.108 0.111c-0.236 0.195 -0.452 0.224 -0.752 0.21l-0.058 -0.116 0.112 0.001c0.613 -0.046 0.925 -0.458 1.322 -0.879l0.209 -0.216a50.29 50.29 0 0 0 0.505 -0.531",
    fill: "#929393"
  })), _ref32 || (_ref32 = React.createElement("path", {
    d: "M24.441 16.43c0.318 0.318 0.308 1.042 0.309 1.477a2.917 2.917 0 0 1 -0.135 0.903h-0.058l0.002 -0.123 0.008 -0.755a4.727 4.727 0 0 0 -0.102 -1.069 2.012 2.012 0 0 1 -0.025 -0.431",
    fill: "#959698"
  })), _ref33 || (_ref33 = React.createElement("path", {
    d: "M34.368 33.149a1.006 1.006 0 0 1 -0.291 0.406h-0.116l-0.043 0.102a1.308 1.308 0 0 1 -0.305 0.363h-0.116l-0.041 0.101c-0.092 0.162 -0.202 0.257 -0.343 0.378l-0.144 0.125 -0.111 0.094c0 -0.212 0.065 -0.261 0.209 -0.406l0.092 -0.09 0.093 -0.093 0.195 -0.194 0.299 -0.298 0.189 -0.188 0.091 -0.091c0.212 -0.209 0.212 -0.209 0.342 -0.209",
    fill: "#949696"
  })), _ref34 || (_ref34 = React.createElement("path", {
    d: "M7.896 33.149c0.203 0.088 0.335 0.204 0.49 0.36l0.146 0.147 0.151 0.153 0.152 0.152c0.404 0.407 0.404 0.407 0.57 0.639l-0.174 0.058 -0.074 -0.088a9.052 9.052 0 0 0 -0.664 -0.7c-0.074 -0.082 -0.074 -0.082 -0.074 -0.198h-0.116c-0.177 -0.159 -0.316 -0.301 -0.406 -0.522",
    fill: "#999B9B"
  })), _ref35 || (_ref35 = React.createElement("path", {
    d: "m11.031 32.859 0.174 0.058 -0.28 0.257 -0.157 0.145c-0.144 0.12 -0.144 0.12 -0.318 0.177l-0.052 0.105c-0.082 0.165 -0.193 0.254 -0.333 0.374l-0.144 0.125 -0.11 0.094 -0.058 -0.116 0.118 -0.117 0.388 -0.39 0.231 -0.233 0.119 -0.121 0.114 -0.115 0.104 -0.104c0.088 -0.082 0.088 -0.082 0.204 -0.14",
    fill: "#959798"
  })), _ref36 || (_ref36 = React.createElement("path", {
    d: "M34.949 11.263v0.174l-0.091 0.079c-0.098 0.089 -0.098 0.089 -0.076 0.214 0.086 0.29 0.246 0.543 0.395 0.806l0.071 0.129 0.066 0.117c0.041 0.107 0.041 0.107 -0.017 0.281l-0.283 -0.537 -0.081 -0.154 -0.078 -0.149 -0.071 -0.137 -0.066 -0.127 -0.067 -0.126c-0.049 -0.107 -0.049 -0.107 -0.045 -0.222 0.077 -0.165 0.198 -0.243 0.345 -0.348",
    fill: "#969797"
  })), _ref37 || (_ref37 = React.createElement("path", {
    d: "M7.489 6.851h0.116c-0.084 0.193 -0.191 0.322 -0.339 0.471l-0.132 0.133 -0.138 0.137 -0.138 0.14 -0.132 0.132 -0.122 0.121c-0.103 0.086 -0.103 0.086 -0.219 0.086l-0.058 0.174h-0.116c0.082 -0.206 0.155 -0.251 0.348 -0.348l0.052 -0.109a0.855 0.855 0 0 1 0.271 -0.305c0.154 -0.121 0.154 -0.121 0.257 -0.283h0.116v-0.116h0.116v-0.116h0.116z",
    fill: "#97999A"
  })), _ref38 || (_ref38 = React.createElement("path", {
    d: "M9.23 5.167c0.307 0.255 0.591 0.527 0.871 0.813l-0.116 0.116c-0.246 -0.239 -0.473 -0.494 -0.697 -0.754l-0.192 0.163 -0.109 0.092c-0.107 0.092 -0.107 0.092 -0.199 0.192 -0.08 0.076 -0.08 0.076 -0.196 0.076 0.066 -0.198 0.155 -0.264 0.316 -0.39 0.116 -0.095 0.219 -0.198 0.323 -0.306",
    fill: "#979899"
  })), _ref39 || (_ref39 = React.createElement("path", {
    d: "M25.021 4.006c0.403 0.031 0.75 0.146 1.129 0.287l0.177 0.063c0.428 0.158 0.428 0.158 0.495 0.289 -0.29 -0.049 -0.559 -0.146 -0.835 -0.243a3.52 3.52 0 0 0 -0.675 -0.163v-0.116l-0.291 -0.058z",
    fill: "#949596"
  })), _ref40 || (_ref40 = React.createElement("path", {
    d: "m27.402 28.099 0.116 0.058a10.058 10.058 0 0 1 -1.077 0.907l-0.107 0.077c-0.252 0.176 -0.252 0.176 -0.383 0.176v-0.116a7.041 7.041 0 0 1 0.366 -0.265c0.377 -0.263 0.733 -0.541 1.085 -0.838",
    fill: "#999A9C"
  })), _ref41 || (_ref41 = React.createElement("path", {
    d: "M27.344 6.502c0.269 0.058 0.462 0.145 0.693 0.294 0.318 0.198 0.556 0.258 0.932 0.203l0.116 -0.032a0.573 0.573 0 0 1 -0.33 0.225c-0.521 0.02 -0.995 -0.348 -1.411 -0.632z",
    fill: "#969798"
  })), _ref42 || (_ref42 = React.createElement("path", {
    d: "m14.688 8.767 -0.168 0.09 -0.227 0.121 -0.12 0.063a56.325 56.325 0 0 0 -0.868 0.474c-0.127 0.065 -0.127 0.065 -0.301 0.124v-0.116l0.595 -0.341 0.17 -0.098 0.164 -0.095 0.151 -0.086c0.383 -0.213 0.383 -0.213 0.602 -0.135",
    fill: "#959798"
  })), _ref43 || (_ref43 = React.createElement("path", {
    d: "M17.01 30.594c0.35 0.032 0.695 0.083 1.041 0.142l0.134 0.021c0.321 0.055 0.321 0.055 0.451 0.185a4.325 4.325 0 0 1 -0.943 -0.076l-0.122 -0.021c-0.227 -0.042 -0.388 -0.094 -0.56 -0.251",
    fill: "#979899"
  })), _ref44 || (_ref44 = React.createElement("path", {
    d: "M23.222 14.455c0.448 0.183 0.719 0.709 0.945 1.114l0.041 0.105 -0.058 0.116 -0.115 -0.178 -0.154 -0.235 -0.075 -0.117a3.017 3.017 0 0 0 -0.43 -0.536l-0.154 -0.152z",
    fill: "#959697"
  })), _ref45 || (_ref45 = React.createElement("path", {
    d: "M20.261 1.973h2.555l-0.232 0.174 -0.058 -0.058a14.081 14.081 0 0 0 -0.501 -0.018l-0.152 -0.004 -0.483 -0.011 -0.327 -0.008 -0.802 -0.016z",
    fill: "#9FA0A2"
  })), _ref46 || (_ref46 = React.createElement("path", {
    d: "m22.351 21.886 -0.125 0.074c-0.338 0.204 -0.338 0.204 -0.525 0.535 0.011 0.206 0.031 0.406 0.069 0.61h-0.116c-0.116 -0.23 -0.09 -0.504 -0.058 -0.754 0.139 -0.289 0.432 -0.572 0.754 -0.465",
    fill: "#969898"
  })), _ref47 || (_ref47 = React.createElement("path", {
    d: "m18.52 13.469 -0.098 0.05 -0.44 0.229 -0.154 0.079 -0.149 0.077 -0.137 0.07a3.017 3.017 0 0 0 -0.36 0.247l-0.116 -0.058a4.526 4.526 0 0 1 0.889 -0.577l0.108 -0.056c0.259 -0.129 0.259 -0.129 0.455 -0.063",
    fill: "#939495"
  })), _ref48 || (_ref48 = React.createElement("path", {
    d: "m25.892 29.434 -0.45 0.254 -0.129 0.072 -0.125 0.07 -0.115 0.064 -0.111 0.061 -0.12 0.069c-0.113 0.046 -0.113 0.046 -0.287 -0.012q0.284 -0.163 0.569 -0.323l0.163 -0.094 0.157 -0.088 0.145 -0.082c0.127 -0.052 0.127 -0.052 0.301 0.006",
    fill: "#979899"
  })), _ref49 || (_ref49 = React.createElement("path", {
    d: "M21.829 13.527c0.463 0.124 0.844 0.339 1.219 0.639v0.116l0.174 0.058 -0.116 0.116 -0.073 -0.072c-0.362 -0.339 -0.771 -0.564 -1.204 -0.799z",
    fill: "#949597"
  })), _ref50 || (_ref50 = React.createElement("path", {
    d: "m26.996 35.181 0.058 0.116q-0.219 0.101 -0.439 0.199l-0.124 0.057a2.313 2.313 0 0 1 -0.772 0.207c0.137 -0.137 0.229 -0.159 0.413 -0.21l0.16 -0.046 0.123 -0.032v-0.116l0.351 -0.085c0.117 -0.028 0.117 -0.028 0.229 -0.09",
    fill: "#959697"
  })), _ref51 || (_ref51 = React.createElement("path", {
    d: "M8.534 5.921c-0.094 0.234 -0.259 0.392 -0.436 0.566l-0.088 0.09c-0.217 0.215 -0.217 0.215 -0.348 0.215 0.094 -0.234 0.259 -0.392 0.436 -0.566l0.088 -0.09c0.217 -0.215 0.217 -0.215 0.348 -0.215",
    fill: "#969899"
  })), _ref52 || (_ref52 = React.createElement("path", {
    d: "M11.263 28.969c0.208 0.09 0.351 0.215 0.515 0.37 0.206 0.19 0.406 0.356 0.646 0.501l-0.116 0.116c-0.771 -0.616 -0.771 -0.616 -1.045 -0.929z",
    fill: "#939495"
  })), _ref53 || (_ref53 = React.createElement("path", {
    d: "m4.296 7.896 0.174 0.058 -0.104 0.102a9.052 9.052 0 0 0 -0.709 0.768l-0.116 -0.058 0.076 -0.069c0.104 -0.103 0.104 -0.103 0.171 -0.236 0.14 -0.219 0.32 -0.387 0.508 -0.566",
    fill: "#9C9D9E"
  })), _ref54 || (_ref54 = React.createElement("path", {
    d: "m5.283 28.389 0.174 0.058 -0.37 0.377 -0.107 0.109 -0.102 0.104 -0.094 0.096c-0.083 0.069 -0.083 0.069 -0.199 0.069 0.093 -0.226 0.24 -0.368 0.413 -0.537l0.16 -0.157z",
    fill: "#979899"
  })), _ref55 || (_ref55 = React.createElement("path", {
    d: "M10.334 27.924c0.364 0.284 0.656 0.616 0.929 0.987 -0.174 0 -0.174 0 -0.298 -0.117l-0.135 -0.155 -0.134 -0.153 -0.131 -0.156 -0.133 -0.157c-0.1 -0.133 -0.1 -0.133 -0.1 -0.249",
    fill: "#979898"
  })), _ref56 || (_ref56 = React.createElement("path", {
    d: "m30.363 3.483 0.116 0.116c-0.239 0.246 -0.494 0.473 -0.754 0.697l-0.058 -0.116c0.213 -0.263 0.43 -0.488 0.697 -0.697",
    fill: "#989B9B"
  })), _ref57 || (_ref57 = React.createElement("path", {
    d: "m4.18 29.492 0.174 0.058 -0.813 0.813c0.028 -0.248 0.187 -0.393 0.352 -0.566l0.083 -0.09z",
    fill: "#919292"
  })), _ref58 || (_ref58 = React.createElement("path", {
    d: "m5.051 7.141 0.174 0.058 -0.639 0.639 -0.116 -0.116z",
    fill: "#9A9C9D"
  })), _ref59 || (_ref59 = React.createElement("path", {
    d: "M10.334 6.327c0.213 0.09 0.348 0.219 0.508 0.384l0.141 0.144 0.107 0.111c-0.238 0 -0.302 -0.096 -0.476 -0.254l-0.159 -0.143c-0.121 -0.125 -0.121 -0.125 -0.121 -0.241",
    fill: "#969697"
  })), _ref60 || (_ref60 = React.createElement("path", {
    d: "M14.688 4.18c-0.311 0.152 -0.582 0.261 -0.929 0.291V4.355l0.334 -0.12 0.188 -0.067c0.171 -0.044 0.246 -0.049 0.407 0.013",
    fill: "#969898"
  })), _ref61 || (_ref61 = React.createElement("path", {
    d: "M38.955 15.5c0.257 0.078 0.38 0.178 0.522 0.406 0.043 0.221 0.043 0.221 0.058 0.406h-0.116l-0.036 -0.217c-0.051 -0.215 -0.072 -0.241 -0.262 -0.384l-0.167 -0.095z",
    fill: "#929494"
  })), _ref62 || (_ref62 = React.createElement("path", {
    d: "M17.823 9.289q-0.116 0.06 -0.232 0.116l-0.124 0.061c-0.244 0.079 -0.492 0.094 -0.747 0.113 0.058 -0.116 0.058 -0.116 0.204 -0.166l0.184 -0.045 0.182 -0.046c0.182 -0.033 0.348 -0.04 0.533 -0.034",
    fill: "#F4F3F3"
  })), _ref63 || (_ref63 = React.createElement("path", {
    d: "M15.326 29.957c0.229 0.036 0.418 0.109 0.628 0.207l0.172 0.08 0.13 0.06c-0.211 0.07 -0.264 0.039 -0.465 -0.043l-0.153 -0.06a0.905 0.905 0 0 1 -0.312 -0.244",
    fill: "#959797"
  })), _ref64 || (_ref64 = React.createElement("path", {
    d: "M15.617 37.677c0.15 0.224 0.117 0.393 0.095 0.65l-0.01 0.132 -0.027 0.322h-0.058l-0.032 -0.388 -0.018 -0.218c-0.006 -0.181 0.006 -0.323 0.051 -0.497",
    fill: "#949696"
  })), _ref65 || (_ref65 = React.createElement("path", {
    d: "m5.805 8.534 0.058 0.174 -0.086 0.072 -0.113 0.095 -0.113 0.094c-0.101 0.083 -0.101 0.083 -0.153 0.203l-0.174 -0.058z",
    fill: "#97989B"
  })), _ref66 || (_ref66 = React.createElement("path", {
    d: "M19.448 32.395h1.219v0.058h-0.465v0.116l-0.754 -0.116z",
    fill: "#9D9EA0"
  })), _ref67 || (_ref67 = React.createElement("path", {
    d: "M13.469 11.089c0 0.174 0 0.174 -0.096 0.283l-0.126 0.11 -0.125 0.112 -0.119 0.076 -0.174 -0.058 0.221 -0.196 0.125 -0.111c0.119 -0.1 0.119 -0.1 0.293 -0.215",
    fill: "#F5F4F5"
  })), _ref68 || (_ref68 = React.createElement("path", {
    d: "m15.617 2.903 0.116 0.058c0.005 0.281 -0.003 0.536 -0.058 0.813h-0.058c-0.044 -0.304 -0.07 -0.567 0 -0.871",
    fill: "#959697"
  })), _ref69 || (_ref69 = React.createElement("path", {
    d: "m34.949 16.43 0.095 0.131c0.147 0.17 0.3 0.27 0.486 0.392v0.116c-0.228 -0.076 -0.371 -0.16 -0.522 -0.348 -0.043 -0.16 -0.043 -0.16 -0.058 -0.291",
    fill: "#949497"
  })), _ref70 || (_ref70 = React.createElement("path", {
    d: "M16.371 34.775c0.428 0.021 0.428 0.021 0.61 0.207l0.088 0.142 -0.058 0.116 -0.124 -0.138a1.006 1.006 0 0 0 -0.515 -0.269z",
    fill: "#8E9093"
  })), _ref71 || (_ref71 = React.createElement("path", {
    d: "m34.833 32.569 0.116 0.058 -0.116 0.174h-0.116l-0.058 0.174h-0.116l-0.058 0.174 -0.116 -0.116z",
    fill: "#909191"
  })), _ref72 || (_ref72 = React.createElement("path", {
    d: "m22.931 21.306 0.116 0.058 -0.217 0.207 -0.123 0.117 -0.124 0.082 -0.232 -0.058z",
    fill: "#959697"
  })), _ref73 || (_ref73 = React.createElement("path", {
    d: "M29.492 4.296h0.116c-0.047 0.113 -0.047 0.113 -0.116 0.232l-0.174 0.058a5.029 5.029 0 0 0 -0.116 0.232l-0.116 0.058c0.014 -0.109 0.014 -0.109 0.058 -0.232 0.12 -0.072 0.12 -0.072 0.232 -0.116v-0.116h0.116z",
    fill: "#98999A"
  })), _ref74 || (_ref74 = React.createElement("path", {
    d: "m34.368 30.885 0.174 0.058 -0.406 0.406 -0.058 -0.174z",
    fill: "#939495"
  })), _ref75 || (_ref75 = React.createElement("path", {
    d: "m12.424 9.927 0.174 0.058 -0.254 0.203 -0.143 0.115c-0.125 0.089 -0.125 0.089 -0.241 0.089v-0.116c0.096 -0.09 0.096 -0.09 0.221 -0.185l0.125 -0.097z",
    fill: "#939496"
  })), _ref76 || (_ref76 = React.createElement("path", {
    d: "M34.253 8.65c0.24 0.093 0.419 0.268 0.58 0.465v0.116c-0.199 -0.066 -0.254 -0.133 -0.388 -0.291l-0.11 -0.127c-0.082 -0.105 -0.082 -0.105 -0.082 -0.163",
    fill: "#939697"
  })), _ref77 || (_ref77 = React.createElement("path", {
    d: "m31.35 33.905 0.174 0.058 -0.167 0.174 -0.094 0.098c-0.088 0.076 -0.088 0.076 -0.204 0.076 0.075 -0.167 0.155 -0.283 0.291 -0.406",
    fill: "#97999A"
  })), _ref78 || (_ref78 = React.createElement("path", {
    d: "m23.396 20.842 0.174 0.058 -0.167 0.174 -0.094 0.098c-0.088 0.076 -0.088 0.076 -0.203 0.076 0.075 -0.167 0.155 -0.283 0.291 -0.406",
    fill: "#989B9C"
  })), _ref79 || (_ref79 = React.createElement("path", {
    d: "M32.859 7.257c0.22 0.086 0.326 0.218 0.465 0.406h-0.174l-0.047 -0.113c-0.062 -0.139 -0.062 -0.139 -0.243 -0.178z",
    fill: "#929393"
  })), _ref80 || (_ref80 = React.createElement("path", {
    d: "m25.021 4.006 0.221 0.022 0.125 0.012c0.119 0.023 0.119 0.023 0.293 0.14l-0.348 0.058v-0.116l-0.291 -0.058z",
    fill: "#9A9C9D"
  })), _ref81 || (_ref81 = React.createElement("path", {
    d: "m31.002 34.253 0.116 0.116 -0.291 0.232 -0.174 -0.174 0.142 -0.054c0.143 -0.048 0.143 -0.048 0.207 -0.12",
    fill: "#9FA1A2"
  })), _ref82 || (_ref82 = React.createElement("path", {
    d: "m21.771 23.164 0.58 0.232c-0.095 0.04 -0.095 0.04 -0.232 0.058 -0.189 -0.083 -0.189 -0.083 -0.348 -0.174z",
    fill: "#909191"
  })), _ref83 || (_ref83 = React.createElement("path", {
    d: "M28.912 11.089c0.195 0.08 0.29 0.173 0.406 0.348 -0.174 0 -0.174 0 -0.301 -0.109 -0.106 -0.124 -0.106 -0.124 -0.106 -0.239",
    fill: "#9A9B9B"
  })), _ref84 || (_ref84 = React.createElement("path", {
    d: "M34.949 9.23c-0.08 0.195 -0.173 0.29 -0.348 0.406 0 -0.174 0 -0.174 0.109 -0.301 0.124 -0.106 0.124 -0.106 0.239 -0.106",
    fill: "#9A9D9E"
  })), _ref85 || (_ref85 = React.createElement("path", {
    d: "M13.992 25.603h0.116c-0.079 0.171 -0.167 0.321 -0.291 0.465h-0.116c0.079 -0.171 0.167 -0.321 0.291 -0.465",
    fill: "#959697"
  })), _ref86 || (_ref86 = React.createElement("path", {
    d: "m23.164 4.934 0.131 0.079a5.029 5.029 0 0 0 0.392 0.211c-0.16 0.014 -0.16 0.014 -0.348 0 -0.138 -0.116 -0.138 -0.116 -0.232 -0.232z",
    fill: "#9D9D9E"
  })), _ref87 || (_ref87 = React.createElement("path", {
    d: "M37.851 18.346h0.058v0.291h-0.058z",
    fill: "#BABABA"
  })), _ref88 || (_ref88 = React.createElement("path", {
    d: "m18.055 32.453 0.232 0.058Z",
    fill: "#AFAFAF"
  })), _ref89 || (_ref89 = React.createElement("path", {
    d: "m26.705 33.497 0.174 0.058Z",
    fill: "#E2E2E2"
  })), _ref90 || (_ref90 = React.createElement("path", {
    d: "",
    fill: "#A9A9A9"
  })), _ref91 || (_ref91 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref92 || (_ref92 = React.createElement("path", {
    d: "m19.332 13.353 0.174 0.058Z",
    fill: "#CDCDCD"
  })), _ref93 || (_ref93 = React.createElement("path", {
    d: "m15.733 5.457 0.058 0.116 -0.116 -0.058z",
    fill: "#A9A9A9"
  })), _ref94 || (_ref94 = React.createElement("path", {
    d: "m15.152 36.169 0.116 0.058Z",
    fill: "#FFFFFF"
  })), _ref95 || (_ref95 = React.createElement("path", {
    d: "m24.906 36.11 0.116 0.058Z",
    fill: "#D4D4D4"
  })), _ref96 || (_ref96 = React.createElement("path", {
    d: "m22.235 32.395 0.116 0.058Z",
    fill: "#D4D4D4"
  })), _ref97 || (_ref97 = React.createElement("path", {
    d: "m17.01 32.278 0.116 0.058Z",
    fill: "#BFBFBF"
  })), _ref98 || (_ref98 = React.createElement("path", {
    d: "m24.035 31.93 0.116 0.058Z",
    fill: "#D4D4D4"
  })), _ref99 || (_ref99 = React.createElement("path", {
    d: "m21.655 30.711 0.116 0.058Z",
    fill: "#7F7F7F"
  })), _ref100 || (_ref100 = React.createElement("path", {
    d: "m12.83 30.42 0.116 0.058Z",
    fill: "#D4D4D4"
  })), _ref101 || (_ref101 = React.createElement("path", {
    d: "m24.558 29.84 0.116 0.058Z",
    fill: "#FFFFFF"
  })), _ref102 || (_ref102 = React.createElement("path", {
    d: "",
    fill: "#DFDFDF"
  })), _ref103 || (_ref103 = React.createElement("path", {
    d: "m24.847 24.847 0.116 0.058Z",
    fill: "#FFFFFF"
  })), _ref104 || (_ref104 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref105 || (_ref105 = React.createElement("path", {
    d: "m23.513 24.035 0.116 0.058Z",
    fill: "#D4D4D4"
  })), _ref106 || (_ref106 = React.createElement("path", {
    d: "m17.184 23.687 0.116 0.058Z",
    fill: "#BFBFBF"
  })), _ref107 || (_ref107 = React.createElement("path", {
    d: "",
    fill: "#B4B4B4"
  })), _ref108 || (_ref108 = React.createElement("path", {
    d: "",
    fill: "#DFDFDF"
  })), _ref109 || (_ref109 = React.createElement("path", {
    d: "m37.677 22.351 0.116 0.058Z",
    fill: "#7F7F7F"
  })), _ref110 || (_ref110 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref111 || (_ref111 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref112 || (_ref112 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref113 || (_ref113 = React.createElement("path", {
    d: "",
    fill: "#949494"
  })), _ref114 || (_ref114 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref115 || (_ref115 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref116 || (_ref116 = React.createElement("path", {
    d: "",
    fill: "#A9A9A9"
  })), _ref117 || (_ref117 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref118 || (_ref118 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref119 || (_ref119 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref120 || (_ref120 = React.createElement("path", {
    d: "m20.9 13.41 0.116 0.058Z",
    fill: "#D4D4D4"
  })), _ref121 || (_ref121 = React.createElement("path", {
    d: "m33.44 12.947 0.116 0.058Z",
    fill: "#FFFFFF"
  })), _ref122 || (_ref122 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref123 || (_ref123 = React.createElement("path", {
    d: "m21.886 7.489 0.116 0.058Z",
    fill: "#FFFFFF"
  })), _ref124 || (_ref124 = React.createElement("path", {
    d: "m25.951 6.038 0.116 0.058Z",
    fill: "#FFFFFF"
  })), _ref125 || (_ref125 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref126 || (_ref126 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref127 || (_ref127 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref128 || (_ref128 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref129 || (_ref129 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref130 || (_ref130 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref131 || (_ref131 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref132 || (_ref132 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref133 || (_ref133 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref134 || (_ref134 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref135 || (_ref135 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref136 || (_ref136 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref137 || (_ref137 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref138 || (_ref138 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref139 || (_ref139 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref140 || (_ref140 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref141 || (_ref141 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref142 || (_ref142 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref143 || (_ref143 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref144 || (_ref144 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref145 || (_ref145 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref146 || (_ref146 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref147 || (_ref147 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref148 || (_ref148 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref149 || (_ref149 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref150 || (_ref150 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref151 || (_ref151 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref152 || (_ref152 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref153 || (_ref153 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref154 || (_ref154 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref155 || (_ref155 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref156 || (_ref156 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref157 || (_ref157 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref158 || (_ref158 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref159 || (_ref159 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref160 || (_ref160 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref161 || (_ref161 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref162 || (_ref162 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref163 || (_ref163 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref164 || (_ref164 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref165 || (_ref165 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref166 || (_ref166 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref167 || (_ref167 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref168 || (_ref168 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref169 || (_ref169 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref170 || (_ref170 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref171 || (_ref171 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref172 || (_ref172 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref173 || (_ref173 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref174 || (_ref174 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref175 || (_ref175 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref176 || (_ref176 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref177 || (_ref177 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref178 || (_ref178 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref179 || (_ref179 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref180 || (_ref180 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref181 || (_ref181 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref182 || (_ref182 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref183 || (_ref183 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref184 || (_ref184 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref185 || (_ref185 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref186 || (_ref186 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref187 || (_ref187 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref188 || (_ref188 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref189 || (_ref189 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref190 || (_ref190 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref191 || (_ref191 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref192 || (_ref192 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref193 || (_ref193 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref194 || (_ref194 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref195 || (_ref195 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref196 || (_ref196 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref197 || (_ref197 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref198 || (_ref198 = React.createElement("path", {
    d: "",
    fill: "#999999"
  })), _ref199 || (_ref199 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref200 || (_ref200 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref201 || (_ref201 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref202 || (_ref202 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref203 || (_ref203 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref204 || (_ref204 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref205 || (_ref205 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref206 || (_ref206 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref207 || (_ref207 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref208 || (_ref208 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref209 || (_ref209 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref210 || (_ref210 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref211 || (_ref211 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref212 || (_ref212 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref213 || (_ref213 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref214 || (_ref214 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref215 || (_ref215 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref216 || (_ref216 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref217 || (_ref217 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref218 || (_ref218 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref219 || (_ref219 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref220 || (_ref220 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref221 || (_ref221 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref222 || (_ref222 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref223 || (_ref223 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref224 || (_ref224 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref225 || (_ref225 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref226 || (_ref226 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref227 || (_ref227 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref228 || (_ref228 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref229 || (_ref229 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref230 || (_ref230 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref231 || (_ref231 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref232 || (_ref232 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref233 || (_ref233 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref234 || (_ref234 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref235 || (_ref235 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref236 || (_ref236 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref237 || (_ref237 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref238 || (_ref238 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref239 || (_ref239 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref240 || (_ref240 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref241 || (_ref241 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref242 || (_ref242 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref243 || (_ref243 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref244 || (_ref244 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref245 || (_ref245 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref246 || (_ref246 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref247 || (_ref247 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref248 || (_ref248 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref249 || (_ref249 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref250 || (_ref250 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref251 || (_ref251 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref252 || (_ref252 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref253 || (_ref253 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref254 || (_ref254 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref255 || (_ref255 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref256 || (_ref256 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref257 || (_ref257 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref258 || (_ref258 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref259 || (_ref259 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref260 || (_ref260 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref261 || (_ref261 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref262 || (_ref262 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref263 || (_ref263 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref264 || (_ref264 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref265 || (_ref265 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref266 || (_ref266 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref267 || (_ref267 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref268 || (_ref268 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref269 || (_ref269 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref270 || (_ref270 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref271 || (_ref271 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref272 || (_ref272 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref273 || (_ref273 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref274 || (_ref274 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref275 || (_ref275 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref276 || (_ref276 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref277 || (_ref277 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref278 || (_ref278 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref279 || (_ref279 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref280 || (_ref280 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref281 || (_ref281 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref282 || (_ref282 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref283 || (_ref283 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref284 || (_ref284 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref285 || (_ref285 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref286 || (_ref286 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref287 || (_ref287 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref288 || (_ref288 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref289 || (_ref289 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref290 || (_ref290 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref291 || (_ref291 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref292 || (_ref292 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref293 || (_ref293 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref294 || (_ref294 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref295 || (_ref295 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref296 || (_ref296 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref297 || (_ref297 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref298 || (_ref298 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref299 || (_ref299 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref300 || (_ref300 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref301 || (_ref301 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref302 || (_ref302 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref303 || (_ref303 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref304 || (_ref304 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref305 || (_ref305 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref306 || (_ref306 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref307 || (_ref307 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref308 || (_ref308 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref309 || (_ref309 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref310 || (_ref310 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref311 || (_ref311 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref312 || (_ref312 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref313 || (_ref313 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref314 || (_ref314 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref315 || (_ref315 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref316 || (_ref316 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref317 || (_ref317 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref318 || (_ref318 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref319 || (_ref319 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref320 || (_ref320 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref321 || (_ref321 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref322 || (_ref322 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref323 || (_ref323 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref324 || (_ref324 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref325 || (_ref325 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref326 || (_ref326 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref327 || (_ref327 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref328 || (_ref328 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref329 || (_ref329 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref330 || (_ref330 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref331 || (_ref331 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref332 || (_ref332 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref333 || (_ref333 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref334 || (_ref334 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref335 || (_ref335 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref336 || (_ref336 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref337 || (_ref337 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref338 || (_ref338 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref339 || (_ref339 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref340 || (_ref340 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref341 || (_ref341 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref342 || (_ref342 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref343 || (_ref343 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref344 || (_ref344 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref345 || (_ref345 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref346 || (_ref346 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref347 || (_ref347 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref348 || (_ref348 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref349 || (_ref349 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref350 || (_ref350 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref351 || (_ref351 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref352 || (_ref352 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref353 || (_ref353 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref354 || (_ref354 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref355 || (_ref355 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref356 || (_ref356 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref357 || (_ref357 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref358 || (_ref358 = React.createElement("path", {
    d: "",
    fill: "#BFBFBF"
  })), _ref359 || (_ref359 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref360 || (_ref360 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref361 || (_ref361 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref362 || (_ref362 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref363 || (_ref363 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref364 || (_ref364 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref365 || (_ref365 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref366 || (_ref366 = React.createElement("path", {
    d: "",
    fill: "#AAAAAA"
  })), _ref367 || (_ref367 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref368 || (_ref368 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref369 || (_ref369 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref370 || (_ref370 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref371 || (_ref371 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref372 || (_ref372 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref373 || (_ref373 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref374 || (_ref374 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref375 || (_ref375 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref376 || (_ref376 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref377 || (_ref377 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref378 || (_ref378 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref379 || (_ref379 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref380 || (_ref380 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref381 || (_ref381 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref382 || (_ref382 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref383 || (_ref383 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref384 || (_ref384 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref385 || (_ref385 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref386 || (_ref386 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref387 || (_ref387 = React.createElement("path", {
    d: "",
    fill: "#7F7F7F"
  })), _ref388 || (_ref388 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })), _ref389 || (_ref389 = React.createElement("path", {
    d: "",
    fill: "#FFFFFF"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdminIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/admin_Icon.c7b48efa.svg";
export { ForwardRef as ReactComponent };